import Image from "next/future/image";

import classNames from "classnames";

import { useEffect, useRef, useState } from "react";

import TeamTripToDubaiIcon from "assets/careers/icons/team-trip-to-dubai.svg";

import PublicLaunchIcon from "assets/careers/icons/public-launch.svg";

import SeriesAIcon from "assets/careers/icons/series-a.svg";
import StoreAndApiIcon from "assets/careers/icons/store-and-api.svg";
import TeamOf12Icon from "assets/careers/icons/team-of-12.svg";

import SeedIcon from "assets/careers/icons/seed.svg";
import RaySoIcon from "assets/careers/icons/ray.so.svg";
import thomasAndPetr from "assets/careers/thomas-petr@2x.png";
import TodayIcon from "assets/careers/icons/today.svg";

import styles from "./Timeline.module.css";

import type { MouseEventHandler } from "react";

type TimelineItemProps = {
  title: string;
  description: string;
  icon: React.ReactNode;
  year?: number;
  active?: boolean;
  onMouseEnter: MouseEventHandler;
};

const TimelineItem = ({ year, title, description, icon, onMouseEnter, active = false }: TimelineItemProps) => {
  return (
    <div className={classNames(styles.timelineItem, active && styles.active)}>
      <div className={styles.relative}>
        {year ? <span className={styles.year}>{year}</span> : null}
        <div className={styles.relative}>
          <a className={styles.link} onMouseEnter={onMouseEnter}>
            <i className={styles.iconWrapper}>{icon}</i>
          </a>
        </div>
      </div>
      <i className={styles.spacer}></i>
      <div className={styles.details}>
        <h4>{title}</h4>
        <p>{description}</p>
      </div>
    </div>
  );
};

const events = [
  {
    title: "Y Combinator W20",
    description: "Thomas (CEO) and Petr (CTO) kickstarted the journey of Raycast at Y Combinator.",
    icon: <Image src={thomasAndPetr} alt={"Thomas & Petr"} />,
    year: 2020,
  },
  {
    title: "Seed Round",
    description: "We raised $2.7M from Accel, and announced the public beta of the Raycast app.",
    icon: <SeedIcon />,
  },
  {
    title: "Public Launch",
    description: "We announced the public launch of Raycast and said “Hello World” to the internet.",
    icon: <PublicLaunchIcon />,
  },
  {
    title: "Team of 12",
    description: "The team grew to 12 folks, across 7 countries and 2 continents!",
    icon: <TeamOf12Icon />,
    year: 2021,
  },
  {
    title: "ray.so",
    description: "We launched our hackday project, ray.so, which amassed over 2.4k upvotes on Product Hunt.",
    icon: <RaySoIcon />,
  },
  {
    title: "Store & API",
    description: "We launched the Raycast API and Extension Store for Developers and custom extensions.",
    icon: <StoreAndApiIcon />,
  },
  {
    title: "Series A",
    description: "We announced our Series A of $15m, led by Accel and Coatue.",
    icon: <SeriesAIcon />,
  },
  {
    title: "Team Trip to Dubai",
    description: "We ended 2021 with our first team offsite in Dubai, and celebrated the latest announcements!",
    icon: <TeamTripToDubaiIcon />,
  },
  {
    title: "And today...",
    description: "We are a team of 17 folks, and excited at the prospect of you joining our team!",
    icon: <TodayIcon />,
    year: 2022,
  },
];

// TODO: first/last child styles for description
const Timeline = () => {
  const [currentIndex, setCurrentIndex] = useState<number>(0);
  const currentTimer = useRef<NodeJS.Timer>();

  useEffect(() => {
    currentTimer.current = setInterval(() => {
      setCurrentIndex((currentIndex + 1) % events.length);
    }, 5000);

    return () => {
      clearInterval(currentTimer.current);
    };
  }, [currentIndex]);

  return (
    <div className={styles.timeline} id="timeline">
      <div className={styles.timelineInner}>
        {events.map((event, index) => (
          <TimelineItem
            key={event.title}
            title={event.title}
            description={event.description}
            icon={event.icon}
            year={event.year}
            onMouseEnter={() => {
              clearInterval(currentTimer.current);
              setCurrentIndex(index);
            }}
            active={index === currentIndex}
          />
        ))}
      </div>
    </div>
  );
};

export default Timeline;
